import React from 'react';
import PropTypes from 'prop-types';

import { IoChevronDown } from 'react-icons/io5';

import { InputLabel, FormHelperText, FormControl, Select, MenuItem } from '@mui/material';

const SelectFormField = ({
  id,
  name,
  value,
  label,
  error,
  errorMessage,
  helperText,
  noBorder,
  required,
  options,
  onChange,
  onBlur,
  selectProps,
  ...rest
}) => {
  return (
    <FormControl
      variant={label ? 'filled' : 'outlined'}
      error={error || !!errorMessage}
      required={required}
      {...rest}
    >
      {label &&
        <InputLabel id={`${id}-label`} required={required}>
          {label}
        </InputLabel>
      }
      <Select
        labelId={`${id}-label`}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        IconComponent={props => (<IoChevronDown {...props} style={{ top: 'calc(50% - 8px)', color: '#17a17e', fontSize: 20 }}/>)}
        MenuProps={{ transitionDuration: 0, sx: { maxHeight: '50vh' } }}
        className={noBorder ? 'no-border' : ''}
        {...selectProps}
      >
        {!required &&
          <MenuItem value={null}>
            <em>None</em>
          </MenuItem>
        }
        {options.map((option, i) => (
          <MenuItem value={option.value} key={`${id}-option-${i+1}`}>{option.label}</MenuItem>
        ))}
      </Select>
      {(errorMessage || helperText) &&
        <FormHelperText error={!!errorMessage} component="div">
          {errorMessage || helperText}
        </FormHelperText>
      }
    </FormControl>
  );
}

SelectFormField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array
  ]),
  label: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  helperText: PropTypes.node,
  noBorder: PropTypes.bool,
  required: PropTypes.bool,
  options: PropTypes.array,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  selectProps: PropTypes.object,
  fullWidth: PropTypes.bool
};


SelectFormField.defaultProps = {
  id: '',
  name: '',
  label: '',
  value: '',
  error: false,
  errorMessage: '',
  helperText: '',
  noBorder: false,
  required: false,
  options: [],
  onChange: undefined,
  onBlur: undefined,
  selectProps: {},
  fullWidth: true
};

export default SelectFormField;
